import { OnClickTrigger } from './types';

type EventToElement = (event: Event) => Element | undefined;
type NarrowDown = (el: Element) => Element | undefined;

export const element: EventToElement = (event) => {
  if (event.target instanceof Element) {
    return event.target;
  }
  return undefined;
};

export const onClickTrigger = (
  eventToElement: EventToElement,
  narrowDown: NarrowDown[],
  { allowEventPropagation }: Pick<OnClickTrigger, 'allowEventPropagation'> = {}
): OnClickTrigger => {
  return {
    type: 'on-click',
    allowEventPropagation,
    matcher: (event: Event) => {
      let el = eventToElement(event);
      if (!el) {
        return false;
      }
      for (const n of narrowDown) {
        el = n(el);
        if (!el) {
          return false;
        }
      }
      return true;
    },
  };
};

export const button: EventToElement = (event) => {
  const target = element(event);
  if (!target) {
    return;
  }
  const buttonEl = target.closest('button');
  if (buttonEl) {
    return buttonEl;
  }
  return undefined;
};

export const withText = (text: string): NarrowDown => {
  return (el) => {
    if (el.textContent?.includes(text)) {
      return el;
    }
    return undefined;
  };
};

export const insideElementWithTestId = (testId: string): NarrowDown => {
  return (el) => {
    if (el.closest(`[data-testid="${testId}"]`)) {
      return el;
    }
    return undefined;
  };
};
